// extracted by mini-css-extract-plugin
export default {"wrapper":"ChannelViewer_wrapper__qiYwj","hidden":"ChannelViewer_hidden__nmxDY"};